/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
app = {

    smooth_scroll: function(){
      var headerOffset = $('.password-header').outerHeight();
      $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
        	
          // On-page links
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
          ) {
            event.preventDefault();
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              // $('.page__wrapper.loaded').addClass('fade');
              $('html, body').animate({
                scrollTop: (target.offset().top - 20)
              }, 1500, function() {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                // $('.page__wrapper.loaded').removeClass('fade');
                if ($target.is(":focus")) { // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                };
              });
            }
          }
        });

    },
  	open_password_modal: function(){
      $('.password__open-modal').click(function(){
      	console.log('hello');
        $('.password-modal').addClass('password-modal--open');
      });
      
//       &('.password-modal__close').click(function(){
//         $('.password-modal').removeClass('password-modal--open');
//       });
    },
   	auto_scroll_nav: function(){
      // Asigns indexs to each section and appends an anchor tag to the navigation
      // Uses data-section-name to attach name to the anchor.

      // Smooth scroll must be used. 
      //var smoothScroll = MG.smooth_scroll();

      //Gets the index of the last element by getting 
      //the number of elements minus 1
      var lastIndex = $('section.auto-nav').length;
      lastIndex = lastIndex - 1;

      //Number of Sections
      var numSections = $('.auto-nav').length;

      var $section = $('.auto-nav');

      var headerOffset = $('.jump-nav').outerHeight();

      var navTop = ($('.jump-nav').offset().top);
      var navHeight = $('.jump-nav').outerHeight();

      $('.jump-nav__wrapper').css('height', navHeight);
      

      $section.each(function(index, element) {


          // Assigns an numerical id to all section.auto_nav elements
          $(element).attr('id', 'section-' + index);
          // Retrieves the name given to the section.auto_nav element through the data-section-name attribute
          var sectionName = $(element).attr('data-section-name');

          // Auto adds a link to the #nav-links element that will auto scroll to the corosponding section.auto_nav element
          $('.jump-nav .nav-links').append('<li class="blacklist"><h4><a data-section-name="'+ sectionName +'" id="anchor-' + index +'" class="navItem" href="#section-' + index +'">'+ sectionName +'</a></h4></li>');

          // Ensures the first nav element is active on page load
//           $('#anchor-0').addClass('menu__item--current');

          var productTemplateTop = $('.product-template--bike').offset().top;
          var productTemplateHeight = $('.product-template--bike').outerHeight();
          var productTemplateBottom = productTemplateTop + productTemplateHeight;

          console.log('productTemplateBottom: ' + productTemplateBottom);
          if (numSections >= 2) {
              $(window).bind("scroll", function(){


                  // $('nav').addClass('active');

                  

                  // When Scrolling past a section.auto_nav element make corosponding #anchor active
                  var wscroll = $(this).scrollTop();
                  var sectionTop = ($('#section-' + index).offset().top - navHeight - 5); 
                  
                  if (wscroll <= 0) {
                      //$('#anchor-0').addClass('menu__item--current');
                  }
                  // If scrolls to the bottom last anchor is highlighted
                  // Fixxes issue if last .auto-nav element is not tall enought to fill screen
                  else if((wscroll + $(window).height()) == $(document).height()){
                      $('#anchor-' + lastIndex).addClass('menu__item--current');
                      $('#anchor-' + (lastIndex - 1)).removeClass('menu__item--current');
                  }
                  else if (wscroll >= (sectionTop - 2)) {
                      $('#anchor-' + index).addClass('menu__item--current');
                      $('#anchor-' + (index - 1)).removeClass('menu__item--current');
                  }else{
                      $('#anchor-' + index).removeClass('menu__item--current');
                  }

                  if (wscroll >= productTemplateBottom) {
                    $('.jump-nav .nav-link__buy-now').addClass('active');
                  }else{
                    $('.jump-nav .nav-link__buy-now').removeClass('active');
                  }

                  
                  

                  wscroll = false;
                  sectionTop = false;

              });

          }



      });

      //smooth scrolls to the desired section
      $('.navItem').click(function(e){
          e.preventDefault();
          var navHeight = $('.jump-nav').outerHeight();
          $("body, html").css('overflow', 'hidden');
          $("body, html").animate({ scrollTop: ($($(this).attr('href')).offset().top - navHeight) }, 500, "swing", function(){

              setTimeout(function(){
                  $("body, html").css('overflow-y', 'visible'); 
                  if ($('.mobileNavigation__container').hasClass('active')) {
                      $('.mobileNavigation__container').removeClass( 'active' );
                      $('.mobileSubNav-toggle').removeClass( 'active' );

                  }


              }, 500);
          });
      });

      $section = false;

      //smoothScroll = false;
      return false;
  },

  onYouTubeIframeAPIReady: function()  {
    $('.cd-hero__content--video-embed').each(function( index, element ) {
    	var yt_id = $(element).data('yt-id');
      	var video_id = $(element).attr('id');
        var player;
      	var videoHolder = $(element).parent('.cd-hero__content--bg-video');
      	
        player = new YT.Player(video_id, {
            videoId: yt_id, // YouTube Video ID
            host: 'https://www.youtube.com',
            width: 1920,               // Player width (in px)
            height: 1280,              // Player height (in px)
            playerVars: {
              playlist: yt_id,
                autoplay: 1,        // Auto-play the video on load
                autohide: 1,
                disablekb: 1, 
                controls: 0,        // Hide pause/play buttons in player
                showinfo: 0,        // Hide the video title
                modestbranding: 1,  // Hide the Youtube Logo
                loop: 1,            // Run the video in a loop
                fs: 0,              // Hide the full screen button
                autohide: 0,         // Hide video controls when playing
                rel: 0,
                enablejsapi: 1
            },
            events: {
              onReady: function(e) {
                  e.target.mute();
                  e.target.setPlaybackQuality('hd1080');
              },
              onStateChange: function(e) {
                if(e && e.data === 1){
                    
                    
                    if(videoHolder){
                      console.log(videoHolder);
                      videoHolder.removeClass('loading');
                    }
                }else if(e && e.data === 0){
                  e.target.playVideo()
                }
              }
            }
        });
    });

  },
  scrollMagicAnimations: function(){
      // Parallax Scrolling
      var parallaxController = new ScrollMagic.Controller();
      var pinController = new ScrollMagic.Controller();
      var animateController = new ScrollMagic.Controller();

      function parallaxScroling(){
          parallaxController = new ScrollMagic.Controller();
          $(".is-parallax").each(function(index, elment) {
              var parallaxRate = $(this).data('parallaxrate');
             
              var parallax = TweenMax.to($(this), 1, {y: parallaxRate + '%', force3D:true});

              var parallaxElement = new ScrollMagic.Scene({
                      triggerElement: this,
                      triggerHook: 1,
                      duration: '1700%'
              })
              .setTween(parallax)
              .addTo(parallaxController);

          });
        
        
      }

      function pinScrolling(){
          pinController = new ScrollMagic.Controller();
          // Set Pin	    	
          $(".pinned__element").each(function(index, elment) {
              var pinEndElement = $(this).data('pinendelement');
              var pinHeight = $(this).find('.pinned__element__child').height();
              var pinEndHeight = $(pinEndElement).height();
            console.log('pinnedElement: ' + pinEndElement);
            console.log('pinHeight: ' + pinHeight);
            console.log('pinEndHeight: ' + pinEndHeight);
              
              duration = pinEndHeight - pinHeight;
            	console.log(duration);
              var pinElement = new ScrollMagic.Scene({
                      triggerElement: this,
                      triggerHook: 0,
                      duration: duration,
                      reverse: true
              })
              .setPin(this, {pushFollowers: false})
              .setClassToggle(".pinned__element", "active")
              .addTo(pinController);

          });
      }



      function animationScrolling(){
          animateController = new ScrollMagic.Controller();
          // Scrolling Animations		    	
          $(".is-animated").each(function(index, elment) {
              var scrollOffset = $(this).data('scrolloffset');
              var scrollDelay = $(this).data('scrolldelay');
              var animate;

              if ($(this).hasClass('fadeInUp') && $(this).hasClass('content__copy')) {
                  animate = TweenMax.staggerTo($(this).find('p, li, h1, h2, h3, h4, h5, span, strong, em'), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, x: 0, y: 0, z: 0, yPercent: 0, xPercent: 0, delay: scrollDelay, force3D:true}, 0.2);

              }else if($(this).hasClass('fadeIn') && $(this).hasClass('content__copy')) {
                
                
                animate = TweenMax.staggerTo($(this).find('p, li, h1, h2, h3, h4, h5, span, strong, em'), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, delay: scrollDelay, force3D:true}, 0.2);

              }else if ($(this).hasClass('fadeInUp')) {
                  animate = TweenMax.staggerTo($(this), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, x: 0, y: 0, z: 0, yPercent: 0, xPercent: 0, delay: scrollDelay, force3D:true, force3D:true}, 0.2);

              }else if ($(this).hasClass('fadeInDown')) {
                  animate = TweenMax.staggerTo($(this), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, x: 0, y: 0, z: 0, yPercent: 0, xPercent: 0, delay: scrollDelay, force3D:true, force3D:true}, 0.2);

              }else if ($(this).hasClass('fadeInRight')) {
                  animate = TweenMax.staggerTo($(this), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, x: 0, y: 0, z: 0, yPercent: 0, xPercent: 0, delay: scrollDelay, force3D:true, force3D:true}, 0.2);

              }else if ($(this).hasClass('fadeInLeft')) {
                  animate = TweenMax.staggerTo($(this), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, x: 0, y: 0, z: 0, yPercent: 0, xPercent: 0, delay: scrollDelay, force3D:true, force3D:true}, 0.2);

              }else if($(this).hasClass('fadeIn')){
                if($(this).hasClass('featured-slider')){
                  animate = TweenMax.staggerTo($(this), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, delay: scrollDelay}, 0.2);
                }else{
                  animate = TweenMax.staggerTo($(this), 0.6, {className:"+=finish", ease: Sine.easeOut,  opacity:1, delay: scrollDelay, force3D:true}, 0.2);
                }
                  

              }else if($(this).hasClass('fadeInSlow')){
                  animate = TweenMax.staggerTo($(this), 1, {className:"+=finish", ease: Sine.easeOut,  opacity:1, delay: scrollDelay, force3D:true}, 0.2);
            
              }else if($(this).hasClass('slideInRight')){
                if($(this).hasClass('featured-slider__slides-container--three-quarters')){
                	animate = TweenMax.to($(this), 1, {className:"+=finish", ease: Sine.easeOut, x: 0, z: 0, xPercent: 0, delay: scrollDelay, force3D:true});
                }else{
                	animate = TweenMax.to($(this), 1, {className:"+=finish", ease: Sine.easeOut, x: 0, z: 0, xPercent: 100, delay: scrollDelay, force3D:true});
                }
                
              
              }else if($(this).hasClass('slideInLeft')){
                animate = TweenMax.to($(this), 1, {className:"+=finish", ease: Sine.easeOut, x: 0, z: 0, xPercent: 0, delay: scrollDelay, force3D:true});
              
              }else if($(this).hasClass('slideInUp')){
                animate = TweenMax.to($(this), 1, {className:"+=finish", ease: Sine.easeOut, y: 0, z: 0, yPercent: 0, delay: scrollDelay, force3D:true});
              }


              var animateElement = new ScrollMagic.Scene({
                      triggerElement: this,
                      triggerHook: 'onEnter',
                      offset: scrollOffset,
                      duration: 0
              })
              .setTween(animate)
              .addTo(animateController);

          });

      }

//       $(window).on('load', function(){
          setTimeout(function(){
              animationScrolling();
          }, 500);
          if ($(window).width() > 768) {
              parallaxScroling();
              
              pinScrolling();
          }else if($(window).width() < 768){
             pinController.destroy(true);
             parallaxController.destroy(true);
          }
//       });
      
      var lastWidth = $(window).width();
      $( window ).resize(function() {
        if($(window).width()!=lastWidth){
          animateController.destroy(true);
          animationScrolling();
          lastWidth = $(window).width();
        }
        

          if ($(window).width() > 768) {
              
              pinController.destroy(true);
              pinScrolling();
            
            
              parallaxController.destroy(true);
              parallaxScroling();
          }
      });
  },

  image_sequence_animation: function(){
    var wipeAnimation = new TimelineMax().fromTo(".travel-animation__content", 1, {x:  "100%"}, {x: "-100%", ease: Linear.easeNone});  // in from right
      
    var graph       = document.querySelector('.travel-animation__graph');
    var viewer       = document.querySelector('.travel-animation__sequence'),
        frame_count  = 28,
        offset_value = 100;

    // init controller
    var controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        triggerHook: 0,
        reverse: true
      }
    });

    // build pinned scene
    new ScrollMagic.Scene({
      triggerElement: '.travel-animation__wrapper',
      duration: (frame_count * offset_value) + 'px',
      reverse: true
    })
    .setPin('.travel-animation__wrapper')
    //.addIndicators()
    .setTween(wipeAnimation)
    .addTo(controller);

    // build step frame scene
    for (var i = 1, l = frame_count; i <= l; i++) {
      new ScrollMagic.Scene({
          triggerElement: '.travel-animation__wrapper',
          offset: i * offset_value
        })
        .setClassToggle('.travel-animation__wrapper', 'frame' + i)
        //.addIndicators()
        .addTo(controller);
    }


  },

  basic_page_loader: function(){
  
      function fadeOutPageLoader(){
        console.log('helo');
        app.scrollMagicAnimations();
          $('.page__wrapper').removeClass('loading');
        $('.page__wrapper').addClass('loaded');
          $('.loading-overlay').removeClass('active');
          setTimeout(function(){
              $('.loading-overlay').addClass('pause');
              $('.loading__container').empty();
          }, 500);
          // Start Spinning Circle
      }

      function pageLoadSequence() {
          setTimeout(function(){

              fadeOutPageLoader();
          }, 0);

      }

      $(window).on('load', pageLoadSequence());


  },
  disablePointerEventScroll: function(){
    var body = document.body;
    var timer = false;

    window.addEventListener('scroll', function() {
      clearTimeout(timer);
      if(!body.classList.contains('disable-hover')) {
        body.classList.add('disable-hover')
      }

      timer = setTimeout(function(){
        body.classList.remove('disable-hover')
      },500);
    }, false);
  },
  geo_chart: function(){
  	$('.geo-row').each(function(index, elment) {
    	$(this).hover(
          function() {
            
            var geoLetter = $(this).attr('id');
            $('.geo-letter--' + geoLetter).addClass('active');
          }, function() {
            $('.geo-letter').removeClass('active');
          }
        );
    });
  
  },
  accordion: function(){
    $('.expand-row').each(function(index, elment) {
      $(this).click(function(){
         $(this).toggleClass('active');
      });
    });
  },
  modal: function(){
  
    
      if( $('.modal-overlay').length){
      

      $('.modal-open').each(function() {

        var modalID = $(this).attr('data-modalID');
        $(this).click(function(){
          console.log('clicked');
          $('#' + modalID).addClass('active');
          //MG.overlayFadeIn('.' + modalID);
          

        });

        
        $('.modal-overlay .close').click(function(){
          
          if ($('.modal-overlay').hasClass('active')) {
            //MG.overlayFadeOut('.modal-overlay');

            
            $('.modal-overlay').removeClass('active');
          }
        });

        $(document).click(function(event) { 
          if(!$(event.target).closest('.modal-container').length && !$(event.target).closest('.modal-open').length) {
            
            if ($('.modal-overlay').hasClass('active')) {
              //MG.overlayFadeOut('.modal-overlay');
              
              $('.modal-overlay').removeClass('active');
            }
          }        
        })


      });
    }
  },
    // Implments Advanced Custom Feilds maps with added functionality for styling and custom icons
    acf_new_map: function($el, mapStyles, iconBase, offsetX, offsetY, scrollable){
      // var
      //var templateDir = template_dir;
      var $markers = $el.find('.marker');
      var styles = mapStyles;
      
      
      // vars
      var args = {
        mapTypeControlOptions: {
          mapTypeIds: ['Styled']
        },
        scrollwheel: scrollable,
        maxZoom:19,
        minZoom:2,
        center: new google.maps.LatLng(0, 0),
        disableDefaultUI: true,  
        mapTypeId: 'Styled',
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: true
      };
      
      
      // create map  
      var map = new google.maps.Map( $el[0], args);          
      var styledMapType = new google.maps.StyledMapType(styles, { name: 'Styled' });
      

      map.mapTypes.set('Styled', styledMapType);
      
      // add a markers reference
      map.markers = [];
      
      
      // add markers
      var markerCount = 1;
      $markers.each(function(){
        
        app.acf_new_marker( $(this), map, iconBase, markerCount);
        markerCount = markerCount + 1;
      });

      var clsuterIconFolder = iconBase.split("assets/");
      clsuterIconFolder = clsuterIconFolder[0] + "assets/m-";
      console.log(iconBase);
      console.log(clsuterIconFolder);


      var markerCluster = new MarkerClusterer(map, map.markers, {imagePath: clsuterIconFolder});

      // console.log(map.markers);

      $('.legend__markers ul').each(function(parentIndex, parentElement){

        $(parentElement).children("li").each(function(childIndex, childElement) {
          $(childElement).click(function(childIndex) {
            return function(childElement) {
              var mapID = $(this).attr('data-marker-id');
              google.maps.event.trigger(map, 'click');

              if ($(parentElement).parents('.spec-tab-content').hasClass('active')) {

                google.maps.event.trigger(map.markers[childIndex], 'click');
                $(this).addClass('active');
              }
            }
          }(childIndex));
        });
        
      });

      $('.map-tab-container .spec-tab').click(function(){
        $('.map_link').removeClass('active');
        google.maps.event.trigger(map, 'click');
        app.acf_center_map( map );
      });

      $('.ui-link').click(function(){
        $('.map_link').removeClass('active');
        google.maps.event.trigger(map, 'click');
      });

      $('.mobile-spec-tabs').change(function(){
        console.log('changed');
        $('.map_link').removeClass('active');
        google.maps.event.trigger(map, 'click');
        app.acf_center_map( map );
        // map.setZoom(12);
      });

      $('.custom-select').click(function(){
        
        $('.map_link').removeClass('active');
        google.maps.event.trigger(map, 'click');
        app.acf_center_map( map );
        map.setZoom(12);
      });
      


      
      
      $markers = null;
      // center map
      
      app.acf_center_map( map );

      
      map.panBy(offsetX, offsetY);
      // return
      return map;

    },

    acf_new_marker: function($marker, map, iconBase, iconNumber){
      
      // var templateDir = template_dir;
      var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
      var markerType = $marker.attr('data-marker-type');
      var markerID = $marker.attr('data-marker-id');
      
      
      var iconBase = iconBase;
      var iconHeight = 50;
      var iconwidth = 50;
      var iconX = 25;
      var iconY = 25;
      var iconExtention = '.png';
      //var detectIE = MG.detectIE();
      
      
      iconHeight = 32;
      iconwidth = 32;
      iconX = 0;
      iconY = 16;
      

      //console.log(markerType + ': lat:' + $marker.attr('data-lat') + 'Lng: ' + $marker.attr('data-lng') + 'iconHeight: ' + iconHeight);

      
      var icon = {
          url: iconBase, // url
          size: new google.maps.Size(iconwidth, iconHeight),
          //scaledSize: new google.maps.Size(20, 20), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(iconX, iconY) // anchor
      };
      

      // create marker
      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: icon,
        visible: true,
        id: markerID
      });

      // add to array
      map.markers.push( marker );

      var xOffset = 0;
      var yOffset = 35;

      // if($(window).width() < 768 && $(window).width() > 640){
      //   xOffset = -13;
      //   yOffset = 82;
      // }

      // if marker contains HTML, add it to an infoWindow
      if( $marker.html() )
      {
        
          // create info window
          var infoboxOptions = {
            content: $marker.html(),
            disableAutoPan: false,
                maxWidth: 300,
                closeBoxMargin: "15px 15px 0px 0px",
                //closeBoxURL: templateDir + "/img/icons/map-icons/close/map-pin-close-x.png",
                boxStyle: {
                textAlign: "center",
                width: "300px"
            },
            pixelOffset: new google.maps.Size(0, 0)
          };
          var infowindow = new google.maps.InfoWindow({
            content: $marker.html(),
            pixelOffset: new google.maps.Size(xOffset, yOffset),
            minWidth: 220
          });

          // // show info window when marker is clicked & close other markers
          // google.maps.event.addListener(map, 'click', function() {
          //   infowindow.close(map, marker);
          //   // map.setZoom(8);
          //   //app.acf_center_map(map);
          //   $('.legend__markers').removeClass('active');
          // });

          // google.maps.event.addListener(infowindow,'closeclick',function(){
          //    // map.setZoom(8);
          //    app.acf_center_map(map);
          // });

          

          // // show info window when marker is clicked & close other markers
          // google.maps.event.addListener(marker, 'click', function() {

            
          //   infowindow.close(map, marker);
          //   $('.map_link').removeClass('active');
          //   $('.legend__markers').find('[data-marker-id="' + this.id + '"]').addClass('active');
          //   google.maps.event.trigger(map, 'click');
          //   map.setZoom(14);
          //   map.panTo(latlng);
          //   infowindow.open(map, this);
            
            
          // });

          // show info window when marker is clicked & close other markers
          google.maps.event.addListener(map, 'click', function() {
            // infowindow.close(map, marker);
            // map.setZoom(8);
            $('.legend__markers').removeClass('active');
            
          });

          google.maps.event.addListener(infowindow,'closeclick',function(){
            $('.map_link').removeClass('active');
             // map.setZoom(8);
             app.acf_center_map(map);
          });

          // show info window when marker is clicked & close other markers
          google.maps.event.addListener(marker, 'click', function() {

            if (markerType != 'home') {
              infowindow.close(map, marker);
              $('.map_link').removeClass('active');
              $('.legend__markers').find('[data-marker-id="' + this.id + '"]').addClass('active');
              google.maps.event.trigger(map, 'click');
              map.setZoom(14);
              map.panTo(latlng);
              infowindow.open(map, this);
              console.log('hello')
            }
          });
       

      }




      },

      acf_center_map: function( map ) {
      // vars
      var bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

      });

      // only 1 marker?
      if( map.markers.length == 1 )
      {
        // set center of map
        map.setZoom( 16 );
        map.setCenter( bounds.getCenter() );

      }
      else
      {
        // fit to bounds
        //map.setZoom( 10 );
        map.fitBounds( bounds );
      }

      console.log('centered');

    },
  // Specific Tabs Function
  // Uses the id of the tab to show a content 
  // box with the same class name as the id 
  specific_tabs: function(){

    $('.spec-tab').click(function() {
      $(".spec-tab").removeClass('active');
      $(".spec-tab-content").removeClass('active');
      $( "." + $(this).attr('id')).addClass('active');
      $('.mobile-spec-tabs').val($(this).attr('id'));
      $(this).addClass('active');
      $('#' + $(this).attr('id')).addClass('active');
      
    });

    $('.mobile-spec-tabs').change(function(){
      var selectValue = $(this).val();

      $(".spec-tab").removeClass('active');
      $(".spec-tab-content").removeClass('active');
      $( "." + selectValue).addClass('active');
      $(this).addClass('active');
      $("#" + selectValue).addClass('active');

    });

    $('.custom-select').click(function() {
      $(".spec-tab").removeClass('active');
      $(".spec-tab-content").removeClass('active');
      var tab = $('.select-selected').attr('data-tab');
      $( "." + tab).addClass('active');
      $(this).addClass('active');
      $('#' + $(this).attr('id')).addClass('active');
    });

    

    $(document).click(function(event) {
      if(!$(event.target).closest('.spec-tab.available').length && !$(event.target).closest('.spec-tab-content').length) {
        $(".spec-tab-content.default").addClass('active');
      }
    });

  },
  executeMaps: function(iconBase){
    var mapStyles = 
    [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c9c9c9"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ];
    
    
  $('.acf-map').each(function(){
    if ($(this).hasClass('acf-map--sales-centre')) {
      var map = app.acf_new_map( $(this), mapStyles, iconBase, -300, 0, false);
    }else{
      var map = app.acf_new_map( $(this), mapStyles, iconBase, 0, 0, false);
    }
  });

  }
}
$(document).ready(function(){

	HS.init();
  	//app.onYouTubeIframeAPIReady();
  	app.smooth_scroll();
    if($('.jump-nav').length){
      app.auto_scroll_nav();
    }
    app.accordion();
  	app.basic_page_loader();
  	app.disablePointerEventScroll();
    app.modal();
  	app.geo_chart();
    app.image_sequence_animation();
});